import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  // Realistic testimonials based on voice-of-customer data
  const testimonials = [
    {
      id: 1,
      quote: "AutoMats has truly invested in my business and helped me succeed beyond my expectations. Their partnership approach makes all the difference.",
      attribution: "Mike T., Automotive Dealer"
    },
    {
      id: 2,
      quote: "Their team is always helping and brainstorming with us to find the best solutions. It's like having a business partner, not just a supplier.",
      attribution: "Sarah L., Floor Mat Distributor"
    },
    {
      id: 3,
      quote: "When you call AutoMats, you're not talking to some call center - you're calling real people who actually know the business and care about your success.",
      attribution: "James R., Auto Parts Store Owner"
    },
    {
      id: 4,
      quote: "They solve problems. My customers notice the quality, and I notice the service.",
      attribution: "Lisa M., Dealership Parts Manager"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-automats-off-white to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-automats-eco-green/10 text-automats-eco-green border-automats-eco-green/20 mb-4 font-body">
            Customer Stories
          </Badge>
          <h2 className="text-4xl font-heading font-bold text-automats-black mb-6">
            Trusted by Dealers Nationwide
          </h2>
          <p className="text-xl font-body text-automats-steel max-w-3xl mx-auto leading-relaxed">
            Don't just take our word for it. Here's what real dealers say about 
            their experience with AutoMats.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id} 
              className="hover-lift hover:shadow-xl transition-all duration-300 border-2 hover:border-automats-red/20"
            >
              <CardContent className="p-6">
                <div className="space-y-4">
                  {/* Quote Icon */}
                  <div className="flex justify-center">
                    <Quote className="h-8 w-8 text-automats-red/30" />
                  </div>

                  {/* Quote Text */}
                  <blockquote className="text-lg font-body text-automats-black italic leading-relaxed text-center">
                    "{testimonial.quote}"
                  </blockquote>

                  {/* Attribution */}
                  <div className="text-center pt-4 border-t border-gray-100">
                    <div className="text-sm font-body text-automats-steel">
                      {testimonial.attribution}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-heading font-bold text-automats-black mb-4">
            Ready to Join Our Success Stories?
          </h3>
          <p className="text-lg font-body text-automats-steel mb-8 max-w-2xl mx-auto">
            Experience the AutoMats difference for yourself. Request a sample kit 
            and see why dealers across America choose us.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:sales@automats.us?subject=Sample Kit Request&body=Hello, I would like to request a sample kit to experience the AutoMats difference."
              className="bg-automats-red hover:bg-red-700 text-white px-8 py-3 rounded-lg font-body font-semibold transition-colors focus:ring-4 focus:ring-automats-red/20"
            >
              Request Sample Kit
            </a>
            <a 
              href="mailto:sales@automats.us?subject=Pricing Information&body=Hello, I would like to learn more about AutoMats pricing and products."
              className="border border-automats-steel text-automats-steel hover:bg-automats-steel hover:text-white px-8 py-3 rounded-lg font-body font-semibold transition-colors"
            >
              Get Pricing
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;